export enum FeatureEntitlements {
  AvailabilityScoreOverride = 'availability_score_override_tool',
}
